import { render, staticRenderFns } from "./MasterForm.vue?vue&type=template&id=bbdf8e70&scoped=true"
import script from "./MasterForm.vue?vue&type=script&lang=js"
export * from "./MasterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdf8e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbdf8e70')) {
      api.createRecord('bbdf8e70', component.options)
    } else {
      api.reload('bbdf8e70', component.options)
    }
    module.hot.accept("./MasterForm.vue?vue&type=template&id=bbdf8e70&scoped=true", function () {
      api.rerender('bbdf8e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setup/firmManager/MasterForm.vue"
export default component.exports